import React from "react";
import PropTypes from "prop-types";
import DynamicBreadcrumbsNavItem from "./DynamicBreadcrumbsNavItem";
import Button from "wonderbly-components/lib/Button";
import cx from "classnames";
import Thumbnail from "./Thumbnail";
import Modal from "../../Modal";
import { replaceTextWithValues } from "src/common/utils/text-replace";

const DynamicBreadcrumbsNav = (props) => (
  <div
    className={cx("dynamic-breadcrumb-nav", {
      "dynamic-breadcrumb-nav--open": props.isPickerOpen,
      "dynamic-breadcrumb-nav--page-active": props.isPageActive,
    })}
  >
    <Button
      className="dynamic-breadcrumb-label"
      onClick={props.onClickLetter}
      unstyled
    >
      <div className="dynamic-breadcrumb-letter">{props.bookmark.label}</div>
      <Thumbnail src={props.bookmark.url} alt={props.bookmark.label} />
    </Button>
    {props.isChangeable && (
      <Modal
        bypass={!props.isModal || !props.isPickerOpen}
        className="dynamic-breadcrumb-modal"
        isOpen
      >
        <div className="dynamic-breadcrumb-wrapper">
          {props.isPickerOpen ? (
            [
              <div
                className="dynamic-breadcrumb-options"
                key="dynamic-breadcrumb-options"
              >
                <p className="dynamic-breadcrumb-description">
                  {replaceTextWithValues(
                    props.prismicContent.selectDescription,
                    { letter: props.bookmark.label }
                  )}
                </p>
                <div className="rule--medium" />
                {props.availableOptions.map((char, index) => (
                  <DynamicBreadcrumbsNavItem
                    key={index}
                    index={index}
                    character={char}
                    optionIndex={props.optionIndex}
                    onChangeOption={props.onChangeOption}
                    values={props.values.character_selection}
                    select={props.prismicContent.selectCta}
                    inUse={props.prismicContent.selectInUse}
                  />
                ))}
              </div>,
              <Button
                onClick={props.onClickCancel}
                fullWidth
                className="dynamic-breadcrumb-cancel"
                key="dynamic-breadcrumb-cancel"
              >
                {props.prismicContent.cancelCta}
              </Button>,
            ]
          ) : (
            <Button onClick={props.onClickChange}>
              {props.prismicContent.changeCta}
            </Button>
          )}
        </div>
      </Modal>
    )}
  </div>
);

DynamicBreadcrumbsNav.propTypes = {
  isModal: PropTypes.bool.isRequired,
  onClickLetter: PropTypes.func.isRequired,
  bookmark: PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  isChangeable: PropTypes.bool.isRequired,
  isPickerOpen: PropTypes.bool.isRequired,
  isPageActive: PropTypes.bool.isRequired,
  availableOptions: PropTypes.array.isRequired,
  optionIndex: PropTypes.number.isRequired,
  onChangeOption: PropTypes.func.isRequired,
  onClickChange: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  prismicContent: PropTypes.shape({
    selectDescription: PropTypes.string,
    cancelCta: PropTypes.string,
    changeCta: PropTypes.string,
    selectCta: PropTypes.string,
    selectInUse: PropTypes.string,
  }).isRequired,
  onClickCancel: PropTypes.func.isRequired,
};

export default DynamicBreadcrumbsNav;
